import { QuoteRequestWrapper } from './QuoteStyled';
import { TextField } from "@mui/material";
import New from '../../../images/new.svg';

const Quote = ({ quoteName }) => {
  return (
    <QuoteRequestWrapper>
        <div className="quoteInput">
                <img src={New} alt="img" />
                <h4>Quote Request</h4>
            </div>
            <div className="quoteText">
                <TextField size="small" className="inputField" value={quoteName} InputProps={{
                    readOnly: true,
                }} />
        </div>
    </QuoteRequestWrapper>

  )
}

export default Quote;
